/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatUserUpdateRequest
 */
export interface ChatUserUpdateRequest {
    /**
     * Updated display name of the chat agent
     * @type {string}
     * @memberof ChatUserUpdateRequest
     */
    name?: string;
    /**
     * Updated URL of the agent's avatar image
     * @type {string}
     * @memberof ChatUserUpdateRequest
     */
    avatarUrl?: string;
    /**
     * Updated availability status of the agent
     * @type {string}
     * @memberof ChatUserUpdateRequest
     */
    availabilityStatus?: ChatUserUpdateRequestAvailabilityStatusEnum;
}


/**
 * @export
 */
export const ChatUserUpdateRequestAvailabilityStatusEnum = {
    Online: 'ONLINE',
    Offline: 'OFFLINE'
} as const;
export type ChatUserUpdateRequestAvailabilityStatusEnum = typeof ChatUserUpdateRequestAvailabilityStatusEnum[keyof typeof ChatUserUpdateRequestAvailabilityStatusEnum];


/**
 * Check if a given object implements the ChatUserUpdateRequest interface.
 */
export function instanceOfChatUserUpdateRequest(value: object): value is ChatUserUpdateRequest {
    return true;
}

export function ChatUserUpdateRequestFromJSON(json: any): ChatUserUpdateRequest {
    return ChatUserUpdateRequestFromJSONTyped(json, false);
}

export function ChatUserUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatUserUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'availabilityStatus': json['availabilityStatus'] == null ? undefined : json['availabilityStatus'],
    };
}

export function ChatUserUpdateRequestToJSON(json: any): ChatUserUpdateRequest {
    return ChatUserUpdateRequestToJSONTyped(json, false);
}

export function ChatUserUpdateRequestToJSONTyped(value?: ChatUserUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'avatarUrl': value['avatarUrl'],
        'availabilityStatus': value['availabilityStatus'],
    };
}

